import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import { getCustomerIdOfLoginUser } from '../../../utils/utils';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import Users from '../../../components/Inputs/Users';
import { addUsersInTeam } from '../../../actions/teams';

const formName = 'addUsersInTeamform';

export default function AddUsersInTeam(props) {
    const { teamDetails, projectDetails } = props;
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const dispatch = useDispatch();
    const teamUsersList = useSelector((state) => state.teams.teamUsersList);

    const isValidArray = (elem) => {
        return Array.isArray(elem);
    };

    const previousUsersInTeams = useMemo(() => {
        let previousUsers = [];
        if (isValidArray(teamDetails?.members)) {
            previousUsers = teamDetails?.members.map((elem) => {
                return elem.id;
            });
        }
        return previousUsers;
    }, [teamDetails]);

    const defaultValues = {};

    const submit = (form) => {
        const users = form?.users?.map((elem) => elem?.value);
        const addedMembers = teamUsersList.filter((user) => users.includes(user.value)).map((user) => {
            return user;
        });
        dispatch(addUsersInTeam({ users, teamId: teamDetails.id, formName, teamName: teamDetails.name, addedMembers, source: 'project', projectId: projectDetails.id }));
    };

    const methods = useForm({ defaultValues, mode: 'all' });

    return (
        <Form
            methods={methods}
            onSubmit={(e) => {
                submit(e);
            }}
            buttonPostion={'justify-end'}
            submitButtonName={'Submit'}
            onCancel={() => dispatch(closeModalAction())}
            showSubmit
            submitContainerClassName='flex gap-2 justify-end py-4 px-4'
            isLoading={formButtonLoading[formName]}
        >
            <div className='px-3 flex justify-between'>
                <Users isMulti className='w-full' required name='users' org_id={teamDetails.org_id} filter={previousUsersInTeams} />
            </div>
        </Form>
    );
}
